import React from "react";
import { FaBrain, FaImage, FaQuestionCircle, FaTrophy } from "react-icons/fa";

export default function TechniquesQuizzDashboardHeader() {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="relative overflow-hidden bg-gradient-to-r from-[#013E8E] via-indigo-600 to-blue-600 px-5 py-7 text-white sm:px-7 lg:px-8">
        <div className="absolute -right-16 -top-16 h-44 w-44 rounded-full bg-white/10 blur-2xl" />
        <div className="absolute -bottom-20 -left-16 h-56 w-56 rounded-full bg-[#4CA82F]/20 blur-2xl" />

        <div className="relative flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] ring-1 ring-white/20">
              <FaQuestionCircle />
              Quizz techniques
            </div>

            <h1 className="mt-4 text-2xl font-bold sm:text-3xl">
              Entraînement visuel aux techniques
            </h1>

            <p className="mt-3 max-w-3xl text-sm leading-6 text-white/90 sm:text-base">
              Une image, quatre réponses, un seul bon choix. Idéal pour réviser
              rapidement les noms de techniques sur smartphone.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 lg:min-w-[420px]">
            <HeaderBadge icon={FaImage} label="Reconnaissance image" />
            <HeaderBadge icon={FaBrain} label="Révision rapide" />
            <HeaderBadge icon={FaTrophy} label="Score final" />
          </div>
        </div>
      </div>
    </section>
  );
}

function HeaderBadge({ icon: Icon, label }) {
  return (
    <div className="rounded-2xl bg-white/15 px-4 py-3 text-white ring-1 ring-white/20 backdrop-blur">
      <div className="flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-xl bg-white/15">
          <Icon />
        </span>

        <span className="text-sm font-bold">{label}</span>
      </div>
    </div>
  );
}